import { call, getContext, select } from 'redux-saga/effects';

import { doValidation } from '@elab/core/utils/dynaForms/saga';

export function* doFieldValidation(field, doIfTouchedField = false) {
    const ctx = yield getContext('ctx');
    const fieldData = yield select(ctx.selectors.getDataField, field);
    if ((doIfTouchedField && !fieldData.touched) || !fieldData) {
        return;
    }

    yield call(
        doValidation,
        {
            name: field,
            value: fieldData.value,
            skipValidation: false,
        },
        fieldData.constraints || [],
    );
}
